import React from "react";
import { RecoilRoot } from "recoil";

import { ClinicEdit } from '../uiParts/clinic/ClinicEdit';

import { clinicState } from '../store/clinicState';
import { clinicServiceState } from '../store/clinicServiceState';

const Clinic = (props) => {
  const { clinic, options, clinic_services } = props;

  // 編集の場合の初期値のセット
  const initializeState = ({ set }) => {
    set(clinicState, clinic);
    set(clinicServiceState, clinic_services);
  };

  return (
    <RecoilRoot initializeState={initializeState}>
      <ClinicEdit init_clinic={clinic} options={options} init_clinic_services={clinic_services} />
    </RecoilRoot>
  );
};

export default Clinic;
